import { z } from "zod";
import { ControlDataTypeKey, Types } from "../prop-controllers";
import { P, match } from "ts-pattern";
const socialLinkTypesV0 = [
  "angellist",
  "codepen",
  "discord",
  "dribbble",
  "facebook",
  "github",
  "instagram",
  "linkedin",
  "medium",
  "pinterest",
  "reddit",
  "rss",
  "snapchat",
  "soundcloud",
  "spotify",
  "telegram",
  "tumblr",
  "twitch",
  "twitter",
  "vimeo",
  "whatsapp",
  "yelp",
  "youtube"
];
const socialLinkTypesV1 = [...socialLinkTypesV0, "x", "slack"];
const socialLinkV0Schema = z.object({
  type: z.enum(socialLinkTypesV0),
  url: z.string()
});
const socialLinkV1Schema = z.object({
  type: z.enum(socialLinkTypesV1),
  url: z.string()
});
const socialLinksLinkV0Schema = z.object({
  id: z.string(),
  payload: socialLinkV0Schema
});
const socialLinksLinkV1Schema = z.object({
  id: z.string(),
  payload: socialLinkV1Schema
});
const socialLinksDataV0Schema = z.object({
  links: z.array(socialLinksLinkV0Schema),
  openInNewTab: z.boolean()
});
const socialLinksDataV1Schema = z.object({
  links: z.array(socialLinksLinkV1Schema),
  openInNewTab: z.boolean()
});
const socialLinksDataSchema = z.union([
  socialLinksDataV0Schema,
  socialLinksDataV1Schema
]);
const socialLinksPropControllerDataV1Schema = socialLinksDataSchema;
const SocialLinksPropControllerDataV2Type = "prop-controllers::social-links::v2";
const socialLinksPropControllerDataV2Schema = z.object({
  [ControlDataTypeKey]: z.literal(SocialLinksPropControllerDataV2Type),
  value: socialLinksDataSchema
});
const socialLinksPropControllerDataSchema = z.union([
  socialLinksPropControllerDataV1Schema,
  socialLinksPropControllerDataV2Schema
]);
function SocialLinks(options = {}) {
  return { type: Types.SocialLinks, version: 2, options };
}
function getSocialLinkTypes(descriptor) {
  return match(descriptor).with({ version: P.union(1, 2) }, () => socialLinkTypesV1).otherwise(() => socialLinkTypesV0);
}
function getSocialLinksPropControllerDataSocialLinksData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: SocialLinksPropControllerDataV2Type },
    (v2) => v2.value
  ).otherwise((v0) => v0);
}
function createSocialLinksPropControllerDataFromSocialLinksData(data, definition) {
  return match(definition).with(
    { version: 2 },
    () => ({
      [ControlDataTypeKey]: SocialLinksPropControllerDataV2Type,
      value: data
    })
  ).otherwise(() => data);
}
export {
  SocialLinks,
  SocialLinksPropControllerDataV2Type,
  createSocialLinksPropControllerDataFromSocialLinksData,
  getSocialLinkTypes,
  getSocialLinksPropControllerDataSocialLinksData,
  socialLinksDataSchema,
  socialLinksPropControllerDataSchema
};
//# sourceMappingURL=social-links.js.map